import { Fragment } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PaywallCheckoutPreview } from "@circle-react/types";
import { CheckoutFormSection } from "../../../../CheckoutFormSection";
import { DEFAULT_FULL_PREVIEW_VARIANT } from "../../constants";
import { componentsByVariants } from "./variants";

export interface FuturePaymentsPreviewProps {
  preview: PaywallCheckoutPreview;
  className?: string;
  variant?: keyof typeof DEFAULT_FULL_PREVIEW_VARIANT;
}

export const FuturePaymentsPreview = ({
  preview,
  className,
  variant = DEFAULT_FULL_PREVIEW_VARIANT.default,
}: FuturePaymentsPreviewProps) => {
  if (
    !preview.future_payments ||
    preview.paywall_price.price_type === "onetime"
  ) {
    return null;
  }

  const listOfComponents = (componentsByVariants[variant] ||
    componentsByVariants[DEFAULT_FULL_PREVIEW_VARIANT.default])[
    preview.paywall_price.price_type
  ];

  return (
    <CheckoutFormSection className={classNames("gap-y-2 border-t", className)}>
      <Fragment key={crypto.randomUUID()}>
        {listOfComponents.map(([component, getOptions]) =>
          component({ preview, options: getOptions(preview) || {} }),
        )}
      </Fragment>
    </CheckoutFormSection>
  );
};
